<template>
  <div :class="{'modal': true, 'is-active': alert_modal_flag}">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title" v-text="title"></p>
        <button class="delete" aria-label="close"></button>
      </header>
      <section class="modal-card-body" v-html="content"></section>
      <footer class="modal-card-foot">
        <button class="button is-success" @click="closeModal(true)">Yes</button>
        <button class="button is-danger" @click="closeModal(false)">No</button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      alert_modal_flag: false,
      title: '',
      content: '',
      label: '',
      data: null
    }
  },
  props: ['dataModal'],
  created () {
    this.setData(this.dataModal)
  },
  watch: {
    dataModal (value) {
      this.setData(value)
    }
  },
  methods: {
    setData (value) {
      this.title = value.title
      this.content = value.message
      this.label = value.label
      this.alert_modal_flag = value.show
      this.data = value.data
    },
    closeModal (flag) {
      this.$emit('confirm-event', {label: this.label, flag: flag, data: this.data})
      // this.title = ''
      // this.content = ''
      // this.label = ''
      // this.alert_modal_flag = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/components/ConfirmationModal.vue